// Guided tour for the Risk Calculator. It reuses the Opportunity Calculator's
// tour overlay (spotlight + card); only the steps and the dismissal flag
// differ. Spotlights target `data-calculator-tour="<id>"` elements.

export const RISK_TOUR_STORAGE_KEY = 'cityExplorer:riskCalculatorTour:v1';

const DEFAULT_QUALITY_TEXT = 'the state assessment\u2019s ELA and Math % meeting standard';

const steps = (qualityText) => [
  {
    id: 'filters',
    title: 'Choose which schools to rank',
    body: 'Filter by state, county, city, or school district, by Steady State vs. Phasing In/Out, and by grade band (Elementary, Middle, High). Phasing-in schools are labeled because their peak is usually this year.',
    spotlight: 'filters',
    cardAlign: 'top-right',
  },
  {
    id: 'insights',
    title: 'What the risk picture says',
    body: 'These cards show the share of schools with Moderate or higher enrollment risk, the measures driving risk most often, and high-risk schools paired with nearby low-risk schools. Click a school in the proximity list to open its profile.',
    spotlight: 'insights',
    cardAlign: 'top-right',
  },
  {
    id: 'scoring',
    title: 'Scoring model',
    body: `Open Scoring model to change each measure\u2019s weight, the Low / Moderate / High / Very High tier cutoffs, how missing measures are handled, and the 1\u20135 breakpoints. Academic quality uses ${qualityText}. Share calculator creates a shareable link; filters and settings stay in the URL.`,
    spotlight: 'scoring',
    cardAlign: 'bottom-right',
    expandScoring: true,
  },
  {
    id: 'table',
    title: 'The ranking',
    body: 'Each charter is scored on a 100-point scale where higher means more long-term enrollment risk. Search, sort any column, show all measures, or export CSV. Click a row for the school profile: what drives its score, trends, a comparison with district schools, and a link to the risk map.',
    spotlight: 'table',
    cardAlign: 'top-right',
  },
];

/** Tour steps; `dataset.tourQualityText` names the state's academic-quality measures. */
export const riskTourSteps = (dataset) => steps(dataset?.tourQualityText || DEFAULT_QUALITY_TEXT);

const readFlag = (key) => {
  try {
    return window.localStorage.getItem(key) === '1';
  } catch (_err) {
    return false;
  }
};

export const readRiskTourDismissed = () => readFlag(RISK_TOUR_STORAGE_KEY);

export const writeRiskTourDismissed = () => {
  try {
    window.localStorage.setItem(RISK_TOUR_STORAGE_KEY, '1');
  } catch (_err) {
    // Private browsing or disabled storage should not break the calculator.
  }
};

// The overlay needs the filters, cards, model bar and table on the page, so
// wait for the data (and skip full-screen mode, like the Opportunity tour).
export const shouldShowRiskTour = ({ dismissed, replaying, isFullscreen, ready }) =>
  Boolean(ready && !isFullscreen && (!dismissed || replaying));
